<template>
  <div>
    <TheSideBar v-if="!loading && logged && (role=='contributor' || role=='admin')" v-bind:primary_item="item.xml_id" v-bind:concordances="item.hasOwnProperty('concordances') ? item.concordances : ''"></TheSideBar>
    <div class="ui centered grid">

      <div v-bind:class="class_side" id="page_level_left"></div>
      <!--   <div v-if="!loading" class="ten wide column">-->
      <div v-if="!loading || tabLoad"  v-bind:class="class_center"  id="page_level_center">
        <div class="ui tiny top attached tabular menu">
          <div v-on:click="activateTab(primaryInventory.name)" style="cursor:pointer" class="item" data-tab="first" v-bind:class="{'active':primaryInventory.name==item.inventory.name}">{{primaryInventory.label}}</div>
          <!--  <a v-on:click="activateTab(primaryInventory)" class="item" data-tab="first" v-bind:class="{'active':primaryInventory==item.inventory.name}">{{item.inventory.label}}</a>-->
          <div v-for="item in concordances" :key="item.inventory_name" style="cursor:pointer" v-on:click="activateTab(item.inventory_name,item.items)" class="item" data-tab="" v-bind:class="{'active':activeTab==item.inventory_name}">
            <!-- <div v-if='item.items.length == 1'> <span class="dot" v-bind:class="{'same_as':item.items[0].cert=='same_as',high:item.items[0].cert=='high',medium:item.items[0].cert=='medium',low:item.items[0].cert=='low'}"></span>
                      {{item.inventory_label}}
                      </div>-->
            <div v-if='item.items.length == 1' class="ui left pointing dropdown" name="inventory_menu_hover"> <span class="dot" v-bind:class="{'same_as':item.items[0].cert=='same_as',high:item.items[0].cert=='high',medium:item.items[0].cert=='medium',low:item.items[0].cert=='low'}"></span>
              {{item.inventory_label}}
              <div class="menu">
                <div v-for="prev in item.items" class="item">
                  <ThePreview v-bind:item="prev"></ThePreview>
                </div>
              </div>
            </div>
            <div v-if='item.items.length > 1' class="ui left pointing dropdown" name="inventory_menu">
              {{item.inventory_label + ' …'}}
              <div class="menu">
                <div v-for="prev in item.items" class="item" v-on:click="activateTab(item.inventory_name,[prev])">
                  <ThePreview v-bind:item="prev"></ThePreview>
                </div>
              </div>
            </div>
          </div>

          <div class="right menu">
            <i v-if="item.prevItem!=false&&logged" class="large caret left icon" style="cursor:pointer" v-on:click="callItemPage(item.prevItem)"></i>
            <div :data-tooltip="tooltip('Display the item in sequence of others in the inventory')"><i v-if="logged" class="list icon" id="listicon" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: item.inventory.name, page:item.page,highlight:item.xml_id  } })"></i></div>
            <i v-if="item.nextItem!=false&&logged" class="large caret right icon" style="cursor:pointer" v-on:click="callItemPage(item.nextItem)"></i>
            <span class="italic">Original Inventory ID: {{item.original_inventory_id}} ({{item.xml_id}})</span>&nbsp;&nbsp;&nbsp;
            <div v-if="!rawview" :data-tooltip="tooltip('Show raw data')"><i v-if="logged && (role=='contributor' || role=='admin')" class="database icon" v-on:click="rawview=!rawview" style="cursor:pointer"></i></div>
            <div v-if="rawview" :data-tooltip="tooltip('Show item view')"><i v-if="logged && (role=='contributor' || role=='admin')" class="database icon" v-on:click="rawview=!rawview" style="cursor:pointer"></i></div>
          </div>
        </div>
        <div v-if="loading" class="ui active bottom attached tab segment">
          <div class="ui active centered inline loader"></div><br>
          <div style='width:100%;text-align:center'>Loading...</div>
        </div>
        <div v-if="!loading" class="ui active bottom attached tab segment" data-tab="first">
          <TheItemView v-if="!this.rawview" v-bind:item="item" @layout="changeLayout"></TheItemView>
          <TheRawItemView v-if="this.rawview" v-bind:itemid="item.xml_id"></TheRawItemView>
        </div>
      </div>
      <div  v-bind:class="class_side"  id="page_level_right"></div>

    </div>
  </div>

</template>

<script>
  import TheItemView from '../components/TheItemView.vue'
  import TheRawItemView from '../components/TheRawItemView.vue'
  import TheSideBar from '../components/TheSideBar_v2.vue'
  import TheNoteList from '../components/TheNoteList.vue'
  import ThePreview from '../components/ThePreview.vue'

  export default {
    name: 'item',
    components: {
      TheItemView,
      TheRawItemView,
      TheSideBar,
      TheNoteList,
      ThePreview,

    },
    data() {
      return {
        rawview: false,
        tabLoad: false,
        primaryInventory: {},
        activeTab: "",
        logged: false,
        item: null,
        concordances: [],
        loading: true,
        noteList: null,
        showTooltip: true,
        class_side: { one: true, three: false, four: false, wide: true, column: true },
        class_center: { fourteen: true, ten: false, eight: false, wide: true, column: true },
      


        //  gallery: false

      }
    },
    methods: {
      /* hasGallery:function(value){
         this.gallery=value;
       },*/
      changeLayout: function(type) {
        console.log("type: "+type);
        if (type == 1 || 4) {
          this.class_side.one=false;
          this.class_side.three=false;
          this.class_side.four=true;
          
          this.class_center.eight=true;
          this.class_center.ten=false;
          this.class_center.fourteen=false
        }
        if (type == 2) {
          this.class_side.one=false;
          this.class_side.three=true;
          this.class_side.four=false;
          
          this.class_center.eight=false;
          this.class_center.ten=true;
          this.class_center.fourteen=false
        }
        
        if (type == 3) {
          this.class_side.one=true;
          this.class_side.three=false;
          this.class_side.four=false;
          
          this.class_center.eight=false;
          this.class_center.ten=false;
          this.class_center.fourteen=true
        }
      },
      tooltip: function(str) {
        if (this.showTooltip) return str;
      },
      activateTab: function(tab, items) {
        if (tab == this.primaryInventory.name) {
          this.loadData(true, this.$route.params.itemid);
        }
        else {
          if (items.length == 1) {
            this.loadData(true, items[0].xml_id);
          }

        }
      },
      showPreview: function(inventory_tab) {
        $('#' + inventory_tab).dropdown({ transition: 'drop', on: 'hover' })
      },
      callItemPage: function(id) {
        //  this.items = [];
        this.$router.push({ path: '/item/' + id });
        //  this.items = [];
        //  this.loadData(false, id);
      },

      getPageInTheList: function(items_per_page) {
        this.item.page = Math.floor(this.item.order / items_per_page) + 1;
      },

      makeSemanticActive: function(delay) {
        setTimeout(function() {
          //  $('#listicon').popup();
          $('[name=inventory_menu]').dropdown();
          $('[name= inventory_menu_hover]').dropdown({ action: 'select', on: 'hover' })

          // alert('hello');
        }, delay)
      },

      loadData: function(tabLoad, item_id) {
        this.loading = true;
        this.tabLoad = tabLoad;

        axios
          .get('/api/item/' + item_id)
          .then(response => {
            this.item = response.data;
            this.getPageInTheList( /*items per page*/ 20);
            this.activeTab = response.data.inventory.name;


            if (!tabLoad) {
              this.primaryInventory = {
                name: response.data.inventory.name,
                label: response.data.inventory.label
              }
              this.activeTab = this.primaryInventory.name;
              if (this.item.hasOwnProperty('concordances')) {
                axios
                  .get('/api/concordances/' + this.item.xml_id)
                  .then(response => {
                    //console.log(response.data);
                    this.concordances = response.data;
                    this.loading = false;
                    this.makeSemanticActive(100);
                  });
              }
              else {
                this.concordances = []
                this.loading = false;
                this.makeSemanticActive(100);
              }
            }
            else {
              this.loading = false;
            }
          }).catch(err => {
            if (err.response.status == 401) {
              this.$router.push({
                name: 'not_authorized',
                params: { page: 'item/' + item_id }
              })
            };

          });;
      }
    },
    watch: {
      $route(to, from) {
        this.loadData(false, this.$route.params.itemid);
      },
    },
    beforeMount() {

    },

    mounted() {
      this.loadData(false, this.$route.params.itemid);
    },
    created() {
      axios
        .get('/api/isauth/')
        .then(response => {
          if (response.data.isauth) {
            this.logged = true;
            this.role = response.data.role;
          }
          else {
            this.logged = false;

          }
        })
    }
  }
</script>

<style scoped>
  .dot {
    height: 10px;
    width: 10px;
    margin: 0 2px;
    border-radius: 50%;
    display: inline-block;
  }

  .same_as {
    /* background-color: rgb(0, 0, 0)*/
    /* background-color:gold;*/
    background-color: #004d99
  }

  .high {
    background-color: rgb(44, 109, 53)
      /* background-color: rgb(174, 223, 181)*/
  }

  .medium {
    background-color: rgb(255, 123, 0);
    /*  background-color: rgb(255, 216, 179)*/
  }

  .low {
    background-color: rgb(230, 0, 0);
    /* background-color: #FFAAAA*/
  }
</style>



// WEBPACK FOOTER //
// src/router/item.vue